export * from './lib/models/google-place-result.model';

export * from './lib/google-places.module';
